import * as React from 'react';
import { RISK_POT_REPORT_SEARCH } from '../../utils/RouteConstants';
import { IRiskPotReportSearchParams } from '../../models/IRiskPotReport';
import { Notification } from "./Notification";

interface IRiskPotReportNotifications {
    numberOfRiskPotReportsWithUnreadPreAssessmentDecision: number;
}

export const RiskPotReportNotifications: React.FunctionComponent<IRiskPotReportNotifications> = ({ numberOfRiskPotReportsWithUnreadPreAssessmentDecision }) => {
    const riskPotReportsWithUnreadPreAssessmentSearchParams: IRiskPotReportSearchParams = { onlyShowRiskPotReportsWithUnreadPreAssessmentDecision: true, pageNumber: 1, pageSize: 10, propertyToOrderBy: "RegDate" };
    
    return (
        <>
            {
                numberOfRiskPotReportsWithUnreadPreAssessmentDecision > 0 ?
                    <Notification state={riskPotReportsWithUnreadPreAssessmentSearchParams} amount={numberOfRiskPotReportsWithUnreadPreAssessmentDecision} linkText="Riskpottsärenden med oläst förhandsbedömningsbeslut" linkTo={`/${RISK_POT_REPORT_SEARCH}`} />
                    : null
            }
        </>
    )
}